/**
 * 车型列表
 * https://apidoc.nioint.com/project/6788/interface/api/455350
 */
export const getModelList = '/v1/in/model/list';
/**
 * 保存心愿单
 * https://apidoc.nioint.com/project/6788/interface/api/461487
 */
export const postSave = '/v1/in/configurator/config/save';
/**
 * 查询科技包列表
 * https://apidoc.nioint.com/project/6788/interface/api/464305
 */
export const getDisCountList = '/v1/in/configurator/discount/list';
/**
 * 查询图片
 * https://apidoc.nioint.com/project/6788/interface/api/585053
 */
export const postPicList = '/v1/in/configurator/pic/list';
/**
 * 查询车款和配置
 * https://apidoc.nioint.com/project/6788/interface/api/455491
 */
export const getFeatureList = '/v1/in/configurator/feature/list';
/**
 * 查询价格
 * https://apidoc.nioint.com/project/6788/interface/api/455667
 */
export const postPriceGet = '/v1/in/configurator/price/get';
/**
 * 配置总览
 * https://apidoc.nioint.com/project/6788/interface/api/455651
 */
export const postShowAll = '/v1/in/configurator/feature/show-all';
/**
 * 3D 配置器开关查询
 * https://apidoc.nioint.com/project/6788/interface/api/455659
 */
export const getSwitch3D = '/v1/in/configurator/switch-3d';
/**
 * 查询tip详情
 * https://apidoc.nioint.com/project/6788/interface/api/1391112
 */
export const getTopTip = '/v1/in/configurator/top-tip-detail';
/**
 * 年款组 / 座椅等弹窗信息
 */
export const getGenerationGroupDetailInfo = '/v1/in/configurator/generation-group-detail-info';
/**
 * 车型座椅弹窗（所有）
 */
export const getGenerationGroupDetailInfoByModel = '/v1/in/configurator/generation-group-detail-info/by-model';
/**
 * 查询弹窗配置图片文案
 */
export const getOptionDetail = '/v1/in/configurator/option/detail/info';
/**
 * 查询补贴政策
 * https://apidoc.nioint.com/project/6788/interface/api/620815
 */
export const getSubsidyPolicy = '/v1/in/subsidy/policy/get';
/**
 * 生成短链
 */
export const setValue = '/noauth/uniqueKeyValue/setValue';
/**
 * 新bff生成短链
 */
export const setUniqueValue = '/v1/in/share/setUniqueValue';
/**
 * 解析短链
 */
export const getValue = '/v1/in/share/getUniqueValue';
/**
 *  获取重签弹窗内容 /otd/nioapp/order/reSignContract/detail 【实际无调用】
 */
export const getContractPop = '/api/v1/otd/car/otd/nioapp/order/reSignContract/detail';
/**
 * 配置总览重签协议校验-判断合同重签（配置器）
 * https://apidoc.nioint.com/project/6788/interface/api/1297202
 */
export const reSignCheckConfigurator = '/v1/in/contract/re-sign/check/configurator';
/**
 * 预览合同模版（大定）
 * https://apidoc.nioint.com/project/6788/interface/api/1295917
 */
export const startOrderPreview = '/v1/in/contract/start-order-preview';
// 根据订单号/配置单号+合同type 获取 合同模板预览
export const getPreviewContract = '/api/v1/otd/car/otd/nioapp/order/previewContract';
// 合同签署_点击我已知晓 https://apidoc.nioint.com/project/472/interface/api/377427
export const signContract = '/api/v1/otd/car/otd/nioapp/order/signContract';
/**
 * 更新订单
 */
export const updateOrder = '/v1/in/order/update';
/**
 * 新手引导
 */
export const getGuideList = '/v1/in/guide/new/user';
/**
 * 判断是否可以锁单
 * https://apidoc.nioint.com/project/472/interface/api/783030
 */
export const getIsLockOrder = '/api/v1/otd/car/order/lockable';
/**
 *  发送短信
 * https://apidoc.nioint.com/project/472/interface/api/31068
 */
export const sendMessage = '/api/v1/otd/car/account/send/message/noauth';
/**
 * 锁单接口
 * https://apidoc.nioint.com/project/472/interface/api/783071
 */
export const lockOrder = '/api/v1/otd/car/order/lock';
/**
 * 分享接口
 * https://apidoc.nioint.com/project/6788/interface/api/701981
 */
export const shareInfo = '/v1/in/share/info';
/**
 * 获取小程序二维码
 * https://apidoc.nioint.com/project/6788/interface/api/680989
 */
export const getQrCode = '/v1/in/share/miniProgram/getQrCode';
/**
 * 获取小程序二维码(新)
 * https://apidoc.nioint.com/project/6788/interface/api/1275315
 */
export const getQrCodeNew = '/v1/in/share/xcx/qr-code';
// 获取省份
// export const addressGrade = '/r/vom-address/grade'
export const addressGrade = '/api/v1/otd/car/vom/address/grade';
// 获取二级城市
export const addressSubAddress = '/r/vom-address/subAddress';
/**
 * 省市区
 *  https://apidoc.nioint.com/project/6788/interface/api/1175197
 */
export const getAreaList = '/v1/in/area/list';
// 经纬度获取城市信息
export const addressRgeo = '/r/vom-address/rgeo';
export const getAreaByLocation = '/v1/in/area/get/by/location';
// 获取交付中心列表
export const getCDCList = '/api/v1/otd/car/otd/nioapp/order/queryDeliveryCenter';
// 获取证件类型
export const getCardList = '/api/v1/otd/car/otd/nioapp/queryIdentityType/noauth';
// 一键下单（小定/大定）
export const newcutdown = '/api/v1/otd/car/otd/nioapp/carOrder/createV2';
// 获取支付信息(pay2.0)
export const getPayInfo = '/api/v1/otd/car/otd/nioapp/order/queryPayInfo';
// 查询预订页面下单权益相关信息 盲订
export const getPurchaseInfo = '/api/v1/otd/car/otd/nioapp/order/queryPurchaseInfo';
// 查询预订页面下单权益相关信息 盲订
export const getGenerationInfoByCode = '/v1/in/model/getGenerationInfoByCode';
/**
 * 获取配置修改提示
 * https://apidoc.nioint.com/project/6788/interface/api/731995
 */
export const getChangeOptionTips = '/v1/in/order/getChangeOptionTips';
/**
 * 心愿单信息查询（预订爱车页和小程序心愿单页调用）
 */
export const getWishBasicInfo = '/v1/in/conf/order/basic/info';
/**
 * 预订爱车页价格明细
 */
export const getLoveOrderPrice = '/v1/in/pre/order/price/get';
// 心愿单 获取fellow一句话
export const getFellowMes = '/api/v1/otd/car/otd/nioapp/account/fellow/getFellowInfo';
// 获取该用户的心愿单
export const getWishOrder = '/r/vom-agg/order/select/loveCar/userAccount';
export const getPreOrderCheck = '/v1/in/valid/collect';
/**
 * 配置总览可编辑状态（小程序使用）
 * https://apidoc.nioint.com/project/6788/interface/api/1130594
 */
export const getShowAllEditable = '/v1/in/configurator/show/all/editable';
//
/**
 *  https://apidoc.nioint.com/project/6788/interface/api/1012130
 */
export const getVersionDetail = '/v1/in/model/version-detail';
/**
 * 配置器options规则效验
 */
export const ruleCheck = '/v1/in/configurator/option/rule/check';
/**
 * https://apidoc.nioint.com/project/4412/interface/api/1104160
 * pad端保存心愿单接口
 */
export const postSaveWishByPad = '/v1/configurator/save';
/**
 * https://apidoc.nioint.com/project/4412/interface/api/1104140
 * pad端报价单查询
 *
 */
export const postQuotation = '/v1/quotation/show-all';
/**
 * https://apidoc.nioint.com/project/4412/interface/api/1104151
 * pad端报价单保存
 */
export const saveQuotation = '/v1/quotation/save';
/**
 * https://apidoc.nioint.com/project/4412/interface/api/1104157
 * pad端报价单转心愿单
 */
export const saveWishByQuotationNo = '/v1/quotation/convert-config';
/**
 * https://apidoc.nioint.com/project/4412/interface/api/1201272
 * pad端现车匹配接口/列表
 *
 */
export const existCarList = '/v1/existing-car/existing-car-list';
/**
 * https://apidoc.nioint.com/project/4412/interface/api/867010
 * 查询证件类型
 *
 */
export const getCertificate = '/v1/atm/order/certificate-type';
/**
 * https://apidoc.nioint.com/project/4412/interface/api/1201263
 * 判断现车是否可以预留
 *
 */
export const checkExistCar = '/v1/existing-car/existing-car-check-reserve';
/**
 * https://apidoc.nioint.com/project/4412/interface/api/1201258
 * 现车预留下单并生成报价单接口
 *
 */
export const createExistCarOrder = '/v1/existing-car/create-existing-car-order';
/**
 * https://apidoc.nioint.com/project/4412/interface/api/1201281
 * 报价单立即预定接口
 *
 */
export const createQuotationOrder = '/v1/quotation/quotation-create-order';
/**
 * https://apidoc.nioint.com/project/4412/interface/api/1203043
 * 现车同时在线浏览人数
 *
 */
export const existCarViewUser = '/v1/existing-car/existing-car-online-users';
/**
 * 报价单详情 C端
 */
export const getQuotationDetail = '/v1/in/quotation';
/**
 * 报价单列表 Pad端
 */
export const getQuotationList = '/v1/quotation/list';
/**
 * 报价单操作日志
 * https://apidoc.nioint.com/project/4412/interface/api/1151105
 */
export const getQuotationLog = '/v1/quotation/log';
/**
 * 报价单转心愿单 C端
 */
export const convertConfig = '/v1/in/quotation/convert-config';
/**
 * 获取金融月供
 */
export const getLoanDetail = '/v1/in/finance-calculator/loan-detail';
/**
 * 获取金融方案列表
 */
export const queryFinance = '/v1/finance/pad/products';
/**
 * 获取手机号区号和校验规则
 * https://apidoc.nioint.com/project/4412/interface/api/1139266
 */
export const getAreaCodeList = '/v1/user/area-code-list';
/**
 * 获取脱敏明文数据
 * https://apidoc.nioint.com/project/4412/interface/api/918813
 */
export const decryptSecurityData = '/v1/atm/security/decrypt';
/**
 * 查询交付中心
 * https://apidoc.nioint.com/project/4412/interface/api/866822
 */
export const getDeliveryCenterList = '/v1/atm/order/deliver-center';
/**
 * 查询交付中心列表（省份分级）
 * https://apidoc.nioint.com/project/6788/interface/api/1520643
 */
export const getDeliveryCenterListV2 = '/v1/in/delivery-centers';
/**
 * 组合包列表
 * https://apidoc.nioint.com/project/6788/interface/api/1189200
 */
export const combinationList = '/v1/in/configurator/optional-pack-discount/list';
/**
 * 组合包介绍
 * https://apidoc.nioint.com/project/6788/interface/api/1189365
 */
export const optionalPackageDetail = '/v1/in/configurator/optional-pack-discount/introduce';
/**
 *  * 查询车款售罄弹框接口
 * /v1/in/order/generation-sold-out-popup
 * https://apidoc.nioint.com/project/6788/interface/api/1391219
 */
export const generationSoldOutPopup = '/v1/in/order/generation-sold-out-popup';
/**
 * 心愿单更新到盲订单上
 * https://apidoc.nioint.com/project/6788/interface/api/1391249
 */
export const updateConfOptionBlind = '/v1/in/pre/order/update-conf-option-to-blind';
/**
 * 取消订单
 * https://apidoc.nioint.com/project/6788/interface/api/1178522
 */
export const cancelOrder = '/v1/in/order/cancel';
/**
 * 生成车辆配置KV
 */
export const setVehicleOptions = '/v1/in/share/kv/vehicle-options';
/**
 * 新旧价格对比弹窗接口
 * https://apidoc.nioint.com/project/6788/interface/api/1539092
 */
export const getOldNewPriceCompare = '/v1/in/pre/order/price-update-popup';
/**
 * 购置税速算
 * https://apidoc.nioint.com/project/4412/interface/api/908833
 */
export const postPurchaseTax = '/v1/order/payment/purchase-tax';
